import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";

import { PERMISSIONS } from "../../../config";
import { UserPermissions } from "../user-permissions";
import { IOrdersService } from "./i-orders-service";
import { ITMPv1OrdersService } from "./itmpv1-orders-service";
import { ITOOrdersService } from "./ito-orders-service";

export class OrdersServiceFactory {
  public static getInstance(itemTx: string): IOrdersService {
    const taxonomyId = ItemTaxonomyId.Parse(itemTx);
    const domain: string = taxonomyId.dataDomain ?? "";
    UserPermissions.current.authorize();

    // TODO: Remove ITMPv1 validation since all users should use ITO
    if (UserPermissions.current.hasPermission(PERMISSIONS.USE_V2)) {
      switch (domain) {
        case "amznham":
          return new ITOOrdersService("amznham");
        case "software":
        default:
          return new ITOOrdersService("itmp");
      }
    } else {
      return new ITMPv1OrdersService();
    }
  }

  public static isITO(): boolean {
    return true;
  }
}
